/*! Indoor Hunter motion (adapted from BloomingFlower Motion v2.1 patterns). No libraries.
   Scroll reveals, hero 3D tilt + parallax, card tilt, magnetic buttons, view-transition hooks.
   Off for reduced-motion, no-IntersectionObserver, and design mode. Everything is undone on stop(). */
(function () {
  'use strict';
  if (window.__ihm) return;
  window.__ihm = 1;
  var d = document, root = d.documentElement;
  function mq(q) { try { return matchMedia(q); } catch (e) { return null; } }
  var reduce = mq('(prefers-reduced-motion: reduce)');
  var fine = mq('(hover: hover) and (pointer: fine)');
  var wide = mq('(min-width: 960px)');
  var S = null;
  function ok(m) { return !!(m && m.matches); }
  function lerp(a, b, t) { return a + (b - a) * t; }
  function raf(fn) { var id = requestAnimationFrame(function () { if (S) S.rafs.delete(id); fn(); }); if (S) S.rafs.add(id); return id; }
  function on(t, e, f, o) { var op = { passive: true, signal: S.ac.signal }; if (o) for (var k in o) op[k] = o[k]; t.addEventListener(e, f, op); }
  function undo(f) { S.undo.push(f); }
  function setv(el, k, v) { el.style.setProperty(k, v); }

  function stop() {
    if (!S) return;
    var s = S; S = null;
    try { s.ac.abort(); } catch (e) {}
    s.rafs.forEach(function (i) { cancelAnimationFrame(i); });
    s.obs.forEach(function (o) { try { o.disconnect(); } catch (e) {} });
    for (var i = s.undo.length - 1; i >= 0; i--) { try { s.undo[i](); } catch (e) {} }
    root.classList.remove('ih-js', 'ih-fine');
  }

  function start() {
    stop();
    if (ok(reduce) || !('IntersectionObserver' in window)) return;
    S = { ac: new AbortController(), rafs: new Set(), obs: [], undo: [] };
    try {
      var vh = innerHeight, rows = {}, count = 0;
      var io = new IntersectionObserver(function (en) {
        en.forEach(function (x) {
          if (!x.isIntersecting) return;
          var el = x.target; io.unobserve(el); el.classList.add('ih-in');
          setTimeout(function () { el.classList.remove('ih-rv', 'ih-in'); el.style.removeProperty('--ih-d'); }, 1400);
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
      S.obs.push(io);
      var sel = '.ih-head, .ih-card, .ih-coll, .ih-steps__item, .ih-faq__item, .ih-values__item, .ih-story__card, .ih-story__image, .ih-about__media, .ih-about__features > *, .ih-offer__inner, .product-grid > li, .product-grid__item, .product-recommendations li, .footer__content-top > *';
      d.querySelectorAll(sel).forEach(function (el) {
        if (count >= 80 || el.closest('.ih-hero, dialog, sticky-add-to-cart')) return;
        var r = el.getBoundingClientRect();
        if (r.top < vh || !r.height) return; /* never touch the first screen (LCP) */
        var k = Math.round(r.top / 40); rows[k] = (rows[k] || 0) + 1;
        setv(el, '--ih-d', Math.min(rows[k] - 1, 5) * 70 + 'ms');
        el.classList.add('ih-rv'); undo(function () { el.classList.remove('ih-rv', 'ih-in'); el.style.removeProperty('--ih-d'); });
        io.observe(el); count++;
      });

      var f = ok(fine);
      /* hero: 3D tilt on the photo, depth parallax on floating toys, ambient glow paused off-screen */
      var frame = d.querySelector('.ih-hero__frame');
      if (frame && f && ok(wide)) {
        var tx = 0, ty = 0, cx = 0, cy = 0, px = 0, py = 0, tpx = 0, tpy = 0, hot = false, id = 0;
        var tick = function () {
          id = 0; cx = lerp(cx, tx, 0.12); cy = lerp(cy, ty, 0.12); px = lerp(px, tpx, 0.1); py = lerp(py, tpy, 0.1);
          var m = Math.sqrt(cx * cx + cy * cy);
          setv(frame, '--ih-rot', (m ? (cx / m).toFixed(3) + ' ' + (cy / m).toFixed(3) + ' 0 ' : '1 0 0 ') + m.toFixed(2) + 'deg');
          setv(frame, '--ih-px', px.toFixed(3)); setv(frame, '--ih-py', py.toFixed(3));
          if (m < 0.02 && !hot && Math.abs(px) < 0.002 && Math.abs(py) < 0.002) { return; }
          id = raf(tick);
        };
        on(frame, 'pointermove', function (e) {
          if (e.pointerType !== 'mouse') return;
          var r = frame.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
          tx = (0.5 - y) * 5; ty = (x - 0.5) * 5; tpx = (x - 0.5) * 2; tpy = (y - 0.5) * 2; hot = true;
          if (!id) id = raf(tick);
        });
        on(frame, 'pointerleave', function () { tx = ty = tpx = tpy = 0; hot = false; if (!id) id = raf(tick); });
        frame.classList.add('ih-3d'); undo(function () { frame.classList.remove('ih-3d'); ['--ih-rot', '--ih-px', '--ih-py'].forEach(function (k) { frame.style.removeProperty(k); }); });
      }
      if (frame) {
        var vis = new IntersectionObserver(function (en) { en.forEach(function (x) { frame.classList.toggle('ih-paused', !x.isIntersecting); }); }, { threshold: 0 });
        vis.observe(frame); S.obs.push(vis); undo(function () { frame.classList.remove('ih-paused'); });
      }

      /* cards and tiles: soft 3D tilt (mouse only) */
      if (f) {
        d.querySelectorAll('.ih-card, .ih-coll').forEach(function (el) {
          var ax = 0, ay = 0, cx2 = 0, cy2 = 0, id2 = 0, hover = false;
          var t2 = function () {
            id2 = 0; cx2 = lerp(cx2, ax, 0.18); cy2 = lerp(cy2, ay, 0.18);
            var m = Math.sqrt(cx2 * cx2 + cy2 * cy2);
            if (m < 0.03 && !hover) { el.style.removeProperty('rotate'); return; }
            el.style.setProperty('rotate', (m ? (cx2 / m).toFixed(3) + ' ' + (cy2 / m).toFixed(3) + ' 0 ' : '1 0 0 ') + m.toFixed(2) + 'deg');
            id2 = raf(t2);
          };
          on(el, 'pointermove', function (e) {
            if (e.pointerType !== 'mouse') return;
            var r = el.getBoundingClientRect(), x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
            ax = (0.5 - y) * 6; ay = (x - 0.5) * 6; hover = true; if (!id2) id2 = raf(t2);
          });
          on(el, 'pointerleave', function () { ax = ay = 0; hover = false; if (!id2) id2 = raf(t2); });
          el.classList.add('ih-tilt'); undo(function () { el.classList.remove('ih-tilt'); el.style.removeProperty('rotate'); });
        });
        /* magnetic buttons */
        d.querySelectorAll('.ih-hero .ih-btn, .ih-steps__cta .ih-btn, .product-information .add-to-cart-button').forEach(function (b) {
          var mx = 0, my = 0, cx3 = 0, cy3 = 0, id3 = 0;
          var t3 = function () {
            id3 = 0; cx3 = lerp(cx3, mx, 0.2); cy3 = lerp(cy3, my, 0.2);
            if (Math.abs(cx3) < 0.05 && Math.abs(cy3) < 0.05 && !mx && !my) { b.style.removeProperty('translate'); return; }
            b.style.setProperty('translate', cx3.toFixed(2) + 'px ' + cy3.toFixed(2) + 'px'); id3 = raf(t3);
          };
          on(b, 'pointermove', function (e) {
            if (e.pointerType !== 'mouse') return;
            var r = b.getBoundingClientRect();
            mx = Math.max(-8, Math.min(8, 0.18 * (e.clientX - r.left - r.width / 2)));
            my = Math.max(-6, Math.min(6, 0.18 * (e.clientY - r.top - r.height / 2)));
            if (!id3) id3 = raf(t3);
          });
          on(b, 'pointerleave', function () { mx = my = 0; if (!id3) id3 = raf(t3); });
          undo(function () { b.style.removeProperty('translate'); });
        });
      }

      /* product-card -> product page: shared image transition where View Transitions are supported */
      if ('onpageswap' in window) {
        on(d, 'click', function (e) {
          if (e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
          var a = e.target.closest && e.target.closest('a[href*="/products/"]');
          if (!a || a.target === '_blank' || a.origin !== location.origin) return;
          var card = a.closest('.ih-card, product-card, .product-card') || a;
          var img = card.querySelector('.ih-card__media img, .product-media img, img');
          d.querySelectorAll('[data-ih-vt]').forEach(function (n) { n.style.removeProperty('view-transition-name'); n.removeAttribute('data-ih-vt'); });
          if (img) { img.style.setProperty('view-transition-name', 'ih-product-image'); img.setAttribute('data-ih-vt', ''); }
        }, { capture: true });
        on(window, 'pageshow', function (e) {
          if (e.persisted) d.querySelectorAll('[data-ih-vt]').forEach(function (n) { n.style.removeProperty('view-transition-name'); n.removeAttribute('data-ih-vt'); });
        });
      }

      on(window, 'beforeprint', stop);
      root.classList.add('ih-js'); if (f) root.classList.add('ih-fine');
    } catch (err) { stop(); if (window.console) console.warn('ih motion off:', err); }
  }

  [reduce, fine, wide].forEach(function (m) {
    if (!m) return;
    var h = function () { start(); };
    if (m.addEventListener) m.addEventListener('change', h); else if (m.addListener) m.addListener(h);
  });
  window.IHM = { start: start, stop: stop };
  var go = function () { (window.requestIdleCallback || function (f) { setTimeout(f, 200); })(start, { timeout: 2000 }); };
  if (d.readyState === 'complete') go(); else addEventListener('load', go, { once: true });
})();
